import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { getTranslation } from '../utils/translations';
import { Button } from './UI';
import Logo from './Logo';

const Header = () => {
  const { language, changeLanguage } = useLanguage();
  const { user, logout, isTestMode, toggleTestMode } = useAuth();

  const t = (key) => getTranslation(language, key);

  return (
    <header className="bg-gradient-to-r from-purple-900 to-indigo-900 text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Routes intelligently based on current page */}
          <div className="flex items-center space-x-3">
            <Logo size="medium" />
            <span className="text-xl font-bold">{t('appName')}</span>
          </div>

          {/* Right side */}
          <div className="flex items-center space-x-4">
            {/* Public Navigation */}
            {!user && (
              <>
                <Link to="/" className="text-gray-300 hover:text-white transition text-sm">
                  {t('inicio')}
                </Link>
                <Link to="/about" className="text-gray-300 hover:text-white transition text-sm">
                  {t('aboutUs')}
                </Link>
                <Link to="/interes" className="text-gray-300 hover:text-white transition text-sm">
                  {t('interestRegistration')}
                </Link>
              </>
            )}
            
            {/* Admin Navigation */}
            {user && (
              <>
                <Link to="/" className="text-gray-300 hover:text-white transition text-sm">
                  {t('inicio')}
                </Link>
                <Link to="/about" className="text-gray-300 hover:text-white transition text-sm">
                  {t('aboutUs')}
                </Link>
              </>
            )}
            
            {/* Test Mode Toggle - Admin Only */}
            <button
              onClick={toggleTestMode}
              className={`px-3 py-1 rounded text-sm font-medium transition ${
                isTestMode
                  ? 'bg-yellow-500 text-black'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {isTestMode ? '⚠️ ' + t('testModeActive') : t('testMode')}
            </button>

            {/* Language Selector */}
            <div className="flex items-center space-x-1 bg-purple-800 rounded-lg px-2 py-1">
              {['es', 'en', 'pt'].map((lang) => (
                <button
                  key={lang}
                  onClick={() => changeLanguage(lang)}
                  className={`px-2 py-1 rounded text-sm font-medium transition ${
                    language === lang
                      ? 'bg-yellow-500 text-black'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {lang.toUpperCase()}
                </button>
              ))}
            </div>

            {/* User Menu - Admin Only */}
            {user && (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-gray-300">
                  {user.name} ({t(user.role)})
                </span>
                <button
                  onClick={logout}
                  className="text-sm text-gray-300 hover:text-white transition"
                >
                  {t('logout')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;